/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, perWeek: NonNullable<unknown>, period: NonNullable<unknown> }} Progress_Report_Consistency_UnplannedInputs */

const en_us2_progress_report_consistency_unplanned = /** @type {(inputs: Progress_Report_Consistency_UnplannedInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`${i?.done} in total`);
	return /** @type {LocalizedString} */ (`${i?.done} in total · ${i?.perWeek} a week`)
	
};

const pt_br2_progress_report_consistency_unplanned = /** @type {(inputs: Progress_Report_Consistency_UnplannedInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`${i?.done} no total`);
	return /** @type {LocalizedString} */ (`${i?.done} no total · ${i?.perWeek} por semana`)
	
};

const es_419_progress_report_consistency_unplanned = /** @type {(inputs: Progress_Report_Consistency_UnplannedInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`${i?.done} en total`);
	return /** @type {LocalizedString} */ (`${i?.done} en total · ${i?.perWeek} por semana`)
	
};

const pt_pt2_progress_report_consistency_unplanned = /** @type {(inputs: Progress_Report_Consistency_UnplannedInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`${i?.done} no total`);
	return /** @type {LocalizedString} */ (`${i?.done} no total · ${i?.perWeek} por semana`)
	
};

const fr_fr2_progress_report_consistency_unplanned = /** @type {(inputs: Progress_Report_Consistency_UnplannedInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`${i?.done} au total`);
	return /** @type {LocalizedString} */ (`${i?.done} au total · ${i?.perWeek} par semaine`)
	
};

const de_de2_progress_report_consistency_unplanned = /** @type {(inputs: Progress_Report_Consistency_UnplannedInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`${i?.done} insgesamt`);
	return /** @type {LocalizedString} */ (`${i?.done} insgesamt · ${i?.perWeek} pro Woche`)
	
};

const it_it2_progress_report_consistency_unplanned = /** @type {(inputs: Progress_Report_Consistency_UnplannedInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`${i?.done} in totale`);
	return /** @type {LocalizedString} */ (`${i?.done} in totale · ${i?.perWeek} a settimana`)
	
};

/**
* | period | output |
* | --- | --- |
* | "week" | "{done} in total" |
* | * | "{done} in total · {perWeek} a week" |
*
* @param {Progress_Report_Consistency_UnplannedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_consistency_unplanned = /** @type {((inputs: Progress_Report_Consistency_UnplannedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Consistency_UnplannedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_consistency_unplanned(inputs)
	if (locale === "es-419") return es_419_progress_report_consistency_unplanned(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_consistency_unplanned(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_consistency_unplanned(inputs)
	if (locale === "de-DE") return de_de2_progress_report_consistency_unplanned(inputs)
	if (locale === "it-IT") return it_it2_progress_report_consistency_unplanned(inputs)
	return en_us2_progress_report_consistency_unplanned(inputs)
});
export { progress_report_consistency_unplanned as "progress-report.consistency_unplanned" }